<div class="content-outlet" [class.is-admin-page]="isAdminPage">
  <router-outlet></router-outlet>
</div>
